import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../helpers/export'
import BusinessProvinceService from './service'

export const getBusinessProvinceTable = createAsyncThunk(
  'companyAnalysis/industryOverview/businessProvince/getBusinessProvinceTable',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BusinessProvinceService.getBusinessProvinceTable(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadBusinessProvince = createAsyncThunk(
  'companyAnalysis/industryOverview/businessProvince/downloadBusinessProvince',
  async (params) => {
    try {
      const res = await BusinessProvinceService.downloadBusinessProvince(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
